import { Chip, ChipProps } from '@heroui/react';

interface IChipProps extends ChipProps {
  label: string;
  color?:
    | 'default'
    | 'primary'
    | 'secondary'
    | 'success'
    | 'danger'
    | 'warning';
  variant?:
    | 'solid'
    | 'bordered'
    | 'light'
    | 'flat'
    | 'faded'
    | 'shadow'
    | 'dot';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  radius?: 'sm' | 'md' | 'lg' | 'full';
  startContent?: React.ReactNode;
  endContent?: React.ReactNode;
  onClose?: () => void;
  customClassNames?: {
    base?: string;
    content?: string;
    dot?: string;
    closeButton?: string;
    avatar?: string;
  };
}

const CustomChip = ({
  label = 'lable',
  radius = 'sm',
  color = 'primary',
  variant = 'flat',
  size = 'sm',
  startContent,
  endContent,
  className = '',
  onClose,
  customClassNames,
}: IChipProps) => {
  return (
    <Chip
      size={size}
      color={color}
      variant={variant}
      radius={radius}
      startContent={startContent}
      endContent={endContent}
      className={className}
      onClose={onClose}
      classNames={{
        base: `px-[5px] py-3px ${customClassNames?.base || ''}`,
        content: `text-[11px] leading-[18px] font-semibold ${customClassNames?.content || ''}`,
        ...customClassNames,
      }}
    >
      {label}
    </Chip>
  );
};

export default CustomChip;
